import { Component, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { Observable, switchMap } from 'rxjs';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { PeriodicalValue, PeriodicalValueFormBuilder } from 'src/app/shared/model/PeriodicalValue';
import { ProvisionCalculationType } from 'src/app/shared/model/ProvisionCalculationType';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { FormUtilsService } from 'src/app/shared/services/form-utils.service';
import { PeriodicalValueService } from 'src/app/shared/services/periodical-value.service';

@Component({
  selector: 'app-edit-periodical-value',
  templateUrl: './edit-periodical-value.component.html',
  styleUrls: ['./edit-periodical-value.component.scss']
})
export class EditPeriodicalValueComponent extends DialogContentBase implements OnInit {

  constructor(public dialog: DialogRef,
    private fb: UntypedFormBuilder,
    private periodicalValueService: PeriodicalValueService,
    private customDialogService : CustomDialogService,
    private formUtilsService: FormUtilsService,
    private uiNotification: UiNotificationService) {
    super(dialog);
  }

  @Input() identifier: string;
  error: string;
  addNewFormShown: boolean;
  addNewValueForm: UntypedFormGroup;
  newRecordCalculationType = ProvisionCalculationType.Percent;

  periodicalValues$: Observable<PeriodicalValue[]>;

  @ViewChild("changePeriodicalValueDialog", { read: ViewContainerRef })
  public containerRef: ViewContainerRef;

  ngOnInit(): void {
    this.calculationTypeChanged(this.newRecordCalculationType);
    this.initForm();
  }

  initForm(): void {

    this.loadData();
  }

  loadData() {
    this.periodicalValues$ = this.periodicalValueService.getPeriodicalValues(this.identifier);
  }

  showAddNewForm() {

    const newValue = PeriodicalValueFormBuilder.initPeriodicalValue(this.identifier);
    this.addNewValueForm = PeriodicalValueFormBuilder.getForm(this.fb, newValue);

    this.addNewFormShown = true;
  }

  hideAddNewForm() {
    this.addNewFormShown = false;
  }

  confirmAddNew() {
    if (!this.formUtilsService.markFormGroupTouched(this.addNewValueForm)) {
      this.uiNotification.showValidationError();
      return;
    }


    this.periodicalValueService.addPeriodicalValue(this.addNewValueForm.value).subscribe(
      r => {
        this.uiNotification.showSuccess('validations.dataStoredSuccesfully');
        this.addNewFormShown = false;
        this.loadData();
      });
  }

  calculationTypeChanged(ev: number) {
    this.newRecordCalculationType = ev;
  }

  removeLastValue(){
    this.customDialogService.actionWithConfirmation('admin-center.common.doYouReallyWantToRemoveThisValue',
    () => {
      this.periodicalValueService.deleteLastValue(this.identifier).subscribe(
            x =>  this.loadData());
        },
        this.containerRef);
  }

  close() {

    this.dialog.close({ text: 'OK' });

  }
}